export const INTERNAL_AUTHORIZATION_HEADER = 'x-internal-auth';
export const INTERNAL_AUTHORIZATION_JWT_HEADER = 'x-internal-auth-jwt';
